import { animationCSS, bgStyleObj, shadowCSS } from "../Utils/CssHelper";
import { applyListFunctions } from "../Utils/DynamicValueResolver";
import { LeafRender } from "./PreviewLeafRender";

export function GroupRender({ node, dataCtx, vars, onVarChange, onAction, apiStore, rssStore, globalDataStore, screenNodes, screenRef, visibilityOverrides, onHideModal }) {
  const s = node.styles;
  const d = node.data || {};
  const overflowCSS = s.overflow === "hidden" ? "hidden" : s.overflow === "scroll" ? "auto" : "visible";
  const hideScrollbar = s.overflow === "scroll" && s.hideScrollbar;

  // Visibility: hidden by default if node.visible===false, unless overridden at runtime
  const isVisible = node.visible !== false || visibilityOverrides?.[node.id] === true;

  let resolvedData = null;
  if (d.enabled) {
    if (d.mode === "static") {
      resolvedData = d.staticType === "array" ? (d.staticArray || []) : (d.staticJSON || {});
    } else if (d.mode === "globalSource" && d.sourceId && globalDataStore) {
      resolvedData = globalDataStore[d.sourceId] !== undefined ? globalDataStore[d.sourceId] : null;
    } else if (d.mode === "api" && d.apiCallId && apiStore) {
      resolvedData = apiStore[d.apiCallId] !== undefined ? apiStore[d.apiCallId] : dataCtx;
    } else if (d.mode === "rss" && rssStore) {
      resolvedData = rssStore[node.id] !== undefined ? rssStore[node.id] : null;
    }
  }
  if (Array.isArray(resolvedData)) {
    resolvedData = applyListFunctions(resolvedData, d.listFn, vars);
  }

  const childCtx = d.enabled && Array.isArray(resolvedData) && !d.repeat && resolvedData.length > 0
    ? resolvedData[0]
    : d.enabled && !Array.isArray(resolvedData) && resolvedData !== null && typeof resolvedData === "object"
      ? resolvedData
      : dataCtx;

  const baseStyle = (ox = 0, oy = 0, opMul = 1, itemData = null) => ({
    position: "absolute", left: s.x + ox, top: s.y + oy, width: s.width, height: s.height,
    ...bgStyleObj(s, itemData !== null ? itemData : childCtx),
    borderRadius: s.borderRadius || 0,
    border: s.borderWidth ? `${s.borderWidth}px solid ${s.borderColor || "#36454F"}` : "none",
    opacity: ((s.opacity ?? 100) / 100) * opMul, zIndex: s.zIndex || 1,
    overflow: overflowCSS,
    scrollbarWidth: hideScrollbar ? "none" : "auto",
    msOverflowStyle: hideScrollbar ? "none" : "auto",
    boxShadow: shadowCSS(s),
    filter: s.blur ? `blur(${s.blur}px)` : undefined,
    boxSizing: "border-box",
    animation: animationCSS(s),
  });

  const groupActions = Array.isArray(node.onClick) ? node.onClick : [];
  const hasGroupActions = groupActions.length > 0;
  const handleGroupClick = hasGroupActions ? (e) => {
    e.stopPropagation();
    if (onAction) onAction(groupActions, childCtx);
  } : undefined;

  // Not visible and no runtime override → render nothing
  if (!isVisible) return null;

  const renderChildren = (ctxItem, childItemIdx = 0) => node.children.map(child => {
    if (child.type === "group")
      return <GroupRender key={child.id} node={child} dataCtx={ctxItem} vars={vars} onVarChange={onVarChange} onAction={onAction} apiStore={apiStore} rssStore={rssStore} globalDataStore={globalDataStore} screenNodes={screenNodes} screenRef={screenRef} visibilityOverrides={visibilityOverrides} onHideModal={onHideModal}/>;
    return <LeafRender key={child.id} node={child} dataCtx={ctxItem} vars={vars} onVarChange={onVarChange} onAction={onAction} screenNodes={screenNodes} screenRef={screenRef} globalDataStore={globalDataStore} visibilityOverrides={visibilityOverrides} itemIdx={childItemIdx}/>;
  });

  if (d.enabled && d.repeat && Array.isArray(resolvedData) && resolvedData.length > 0) {
    return <>
      {resolvedData.map((item, idx) => {
        let ox = 0, oy = 0;
        if (d.layout === "column") oy = idx * (s.height + (d.rowGap || 8));
        else if (d.layout === "row") ox = idx * (s.width + (d.colGap || 8));
        else { const col = idx % (d.columns || 2); const row = Math.floor(idx / (d.columns || 2)); ox = col * (s.width + (d.colGap || 8)); oy = row * (s.height + (d.rowGap || 8)); }
        return <div key={idx} className={hideScrollbar ? "kiosk-hs" : undefined} style={{...baseStyle(ox, oy, 1, item), cursor: hasGroupActions ? "pointer" : undefined}} onClick={hasGroupActions ? (e) => { e.stopPropagation(); if (onAction) onAction(groupActions, item); } : undefined}>
          {renderChildren(item, idx)}
        </div>;
      })}
    </>;
  }

  // Modal groups: render a full-screen backdrop so clicking outside closes the modal
  if (node.isModal && visibilityOverrides?.[node.id]) {
    return <>
      <div onClick={e=>{e.stopPropagation();if(onHideModal)onHideModal(node.id);}} style={{position:"absolute",inset:0,zIndex:(s.zIndex||1)-1,cursor:"default"}}/>
      <div className={hideScrollbar?"kiosk-hs":undefined} style={{...baseStyle(),cursor:hasGroupActions?"pointer":undefined}} onClick={handleGroupClick}>
        {renderChildren(childCtx)}
      </div>
    </>;
  }

  return <div className={hideScrollbar ? "kiosk-hs" : undefined} style={{...baseStyle(), cursor: hasGroupActions ? "pointer" : undefined}} onClick={handleGroupClick}>
    {renderChildren(childCtx)}
  </div>;
}